import { render, staticRenderFns } from "./weblogComments.vue?vue&type=template&id=506f893e&"
import script from "./weblogComments.vue?vue&type=script&lang=js&"
export * from "./weblogComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports